module.exports = __webpack_public_path__ + "img/home-bg-01.4ddd6b98.png";